import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import HelpLabel from "./HelpLabel";
const DivisionHelpLabel = ({ title }) => {
    return (_jsx(HelpLabel, { title: title, helpText: "If your company has divisions setup it is important to select the right division here for the correct allocation " }));
};
export default DivisionHelpLabel;
